import {AppState} from '@jobseeker/common-core/types';
import {HiristCalendar} from '@jobseeker/lotus/assets/icons';
import Alert from '@jobseeker/lotus/components/Alert';
import {VersionVariants} from '@jobseeker/lotus/enums';
import {openUrl} from '@jobseeker/common-core/utils/common';
import {Box, Button, Typography} from '@mui/material';
import {Image} from '@jobseeker/lotus/components/Image';
import {useState} from 'react';
import {useSelector} from 'react-redux';

const InterviewInvitesNotifier = () => {
  const {interviewSlots} = useSelector((state: AppState) => state.user);

  const [notify, setNotify] = useState(true);

  if (!interviewSlots) {
    return <></>;
  }

  const {count = 0} = interviewSlots;

  if (count === 0 || !notify) {
    return <></>;
  }

  return (
    <Alert
      width="fit-content"
      background="white"
      icon={
        <Box
          height={50}
          width={50}
          my={0.375}
          borderRadius="50%"
          bgcolor="white"
        >
          <Image
            src={HiristCalendar}
            alt="iimjobsLogo"
            title="Scroll Up"
            height={40}
            width={40}
          />
        </Box>
      }
      sx={{
        border: '1px solid #ededf0',
        borderRadius: '5px',
        position: 'fixed',
        bottom: 100,
        right: 100,
        zIndex: 10,
        opacity: 1,
        alignItems: 'flex-start',
      }}
      variant={VersionVariants.VERSION_TWO}
      show={notify}
      onClose={() => setNotify(false)}
    >
      <Typography fontSize={15} fontWeight={700}>
        You have received {count} interview invite{count > 1 ? 's' : ''}
      </Typography>
      <Button
        variant="contained"
        onClick={() => openUrl('interviews', '_blank')}
        sx={{
          ':hover': {
            bgcolor: 'rgb(245, 88, 45)',
          },
        }}
      >
        Book Slot
      </Button>
    </Alert>
  );
};

export default InterviewInvitesNotifier;
